import { useState, useEffect } from "react";

type Post = {
  id: number;
  title: string;
  slug: string;
  content: string;
  published: 0 | 1;
  created_at: string;
  updated_at: string;
};

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export function BlogPost({ slug }: { slug: string }) {
  const [post, setPost] = useState<Post | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isAdmin, setIsAdmin] = useState(!!localStorage.getItem("blog_token"));

  useEffect(() => {
    setPost(null);
    setError(null);
    fetch(`/api/posts/${encodeURIComponent(slug)}`)
      .then((r) => {
        if (!r.ok) throw new Error("Not found");
        return r.json();
      })
      .then((data) => setPost(data as Post))
      .catch(() => setError("Beitrag nicht gefunden."));
  }, [slug]);

  return (
    <div className="portfolio blog-layout">
      <div className="noise-overlay" aria-hidden="true" />

      <nav className="nav nav--scrolled">
        <a href="#" className="nav-logo">NK</a>
        <div className="nav-links">
          {isAdmin && post && (
            <a href="#admin" className="nav-link" title="Edit this post">
              ✎ Bearbeiten
            </a>
          )}
          <a href="#blog" className="nav-link blog-back-link">← Blog</a>
        </div>
      </nav>

      <section className="blog-page">
        <div className="container">
          {error && <p className="blog-empty">{error}</p>}
          {!post && !error && <p className="blog-empty">Lade…</p>}
          {post && (
            <article>
              <header className="blog-post-header">
                <h1 className="blog-post-title">{post.title}</h1>
                <time className="blog-post-date" dateTime={post.created_at}>
                  {formatDate(post.created_at)}
                </time>
                <div className="blog-post-rule" />
              </header>
              <div
                className="blog-content"
                dangerouslySetInnerHTML={{ __html: post.content }}
              />
            </article>
          )}
        </div>
      </section>

      <footer className="site-footer">
        <span>© 2026 Nicolai Kobras</span>
        <a href="#impressum" className="footer-link">Impressum</a>
      </footer>
    </div>
  );
}
